
<div fxLayout="row" fxLayoutWrap="wrap">
    <div fxFlex.gt-sm="65" fxFlex.gt-xs="65" fxFlex="65">
        <mat-card>
            <mat-card-content>

                <full-calendar #calendar defaultView="dayGridMonth" [plugins]="calendarPlugins" [contentHeight]="10"
                    (dateClick)="handleDateClick($event)" (eventClick)="eventClicked($event)"></full-calendar>

            </mat-card-content>
        </mat-card>
    </div>
    <div fxFlex.gt-sm="35" fxFlex.gt-xs="35" fxFlex="35">
        <mat-card>
            <mat-card-content>
                <h4>Detalles del turno</h4>
                <p>Fecha: <strong *ngIf="appointment && appointment.start">{{appointment.start | date:"dd/MM/yyyy"}}</strong></p>
                <p>Desde: <strong *ngIf="appointment && appointment.start">{{appointment.start | date:"HH:mm"}}</strong></p>
                <p>Hasta: <strong *ngIf="appointment && appointment.start">{{appointment.end | date:"HH:mm"}}</strong></p>
                <div class="button-row">
                    <button mat-raised-button color="warn" (click)="cancelAppointment()">Volver</button>
                    <button mat-raised-button color="warn" [disabled]="!appointment.start" (click)="appointment = {}">Limpiar</button>
                    <button mat-raised-button class="btn-app" (click)="acceptAppointment()">Aceptar</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>